import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

const BRAND = '#8F93FF';

// SAVR isometric cube mark (collapsed-sidebar icon), from the frontier design system.
export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 42 48"
    >
      <path fill={BRAND} fillOpacity="0.7" d="M42 24L21 12V24L31 30L42 24Z" />
      <path
        fill={BRAND}
        d="M21 12.0001L32.0469 18.3206L32.0679 18.3205L42 12.0001L21 8.39233e-05V12.0001Z"
      />
      <path fill={BRAND} d="M21 24L11 18L0 24L21 36V24Z" />
      <path fill={BRAND} fillOpacity="0.7" d="M0 12L10 6L21 12L11 18L0 12Z" />
      <path fill={BRAND} fillOpacity="0.83" d="M21 0L10 6L21 12V0Z" />
      <path fill={BRAND} fillOpacity="0.83" d="M11 18L0 12V24L11 18Z" />
      <path
        fill={BRAND}
        fillOpacity="0.7"
        d="M21 35.9999L9.95312 29.6794L9.9321 29.6795L0 35.9999L21 47.9999V35.9999Z"
      />
      <path fill={BRAND} d="M21 36L31 30L42 36L32 42L21 36Z" />
      <path fill={BRAND} fillOpacity="0.83" d="M42 24L31 30L42 36V24Z" />
      <path fill={BRAND} fillOpacity="0.83" d="M32 42L21 36V48L32 42Z" />
    </svg>
  );
};
